function rasterize(
	svgString: string,
	size = 50,
	interpolation = 1,
): Promise<string> {
	return new Promise((resolve, reject) => {
		// Parse the SVG string into a DOM element
		const parser = new DOMParser();
		const parsedDoc = parser.parseFromString(
			svgString,
			"image/svg+xml",
		).documentElement;

		// Ensure the parsed element is an SVG element by casting to `SVGSVGElement`
		const svgDoc = parsedDoc as unknown as SVGSVGElement;

		// Set the width and height for the SVG
		svgDoc.setAttribute("width", `${size * interpolation}`);
		svgDoc.setAttribute("height", `${size * interpolation}`);

		const image = new Image();

		// Handle image load error
		image.onerror = (err) => {
			// eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
			reject(err);
		};

		// When the image is loaded, draw it on a canvas
		image.onload = () => {
			// Create a canvas and get its 2D context
			const canvas = document.createElement("canvas");
			const context = canvas.getContext("2d");

			if (!context) {
				return reject(new Error("Unable to get canvas context"));
			}

			// Set canvas dimensions
			canvas.width = size * interpolation;
			canvas.height = size * interpolation;

			// Draw the image multiple times based on interpolation factor
			for (let i = 0; i < interpolation; i++) {
				for (let j = 0; j < interpolation; j++) {
					context.drawImage(image, i * size, j * size, size, size);
				}
			}

			// Resolve the promise with the base64-encoded PNG data URL
			resolve(canvas.toDataURL("image/png"));
		};

		// Serialize the SVG and convert it to a base64 data URL
		const serializedSVG = new XMLSerializer().serializeToString(svgDoc);
		const base64Data = window.btoa(serializedSVG);
		image.src = `data:image/svg+xml;base64,${base64Data}`;
	});
}

export default rasterize;
